export default __webpack_public_path__ + "static/media/Mobile-Vimepay.4ecd97ec.png";